import { DeliveryService } from "./types";

// Local type that allows React components for icons
type LocalDeliveryService = Omit<DeliveryService, 'icon'> & {
  icon: any; // Using any to avoid React type conflicts
};

interface ServiceItemProps {
  service: LocalDeliveryService;
}
export const ServiceItem = ({ service }: ServiceItemProps) => {
  const { icon: Icon, title, subtitle, value, valueColor = "text-black" } = service;
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-3">
        <Icon className="w-5 h-5 text-gray-600" />
        <div>
          <p className="text-sm font-medium text-black">{title}</p>
          <p className="text-xs text-gray-600">{subtitle}</p>
        </div>
      </div>
      <span className={`text-sm font-medium ${valueColor}`}>
        {value}
      </span>
    </div>
  );
};